import { render, staticRenderFns } from "./SimpleArticleView.vue?vue&type=template&id=658d5c00&scoped=true&"
import script from "./SimpleArticleView.vue?vue&type=script&lang=ts&"
export * from "./SimpleArticleView.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleArticleView.vue?vue&type=style&index=0&id=658d5c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658d5c00",
  null
  
)

export default component.exports